import { Component, Inject } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";

@Component({
	selector: "app-task-complete-dialog",
	templateUrl: "./task-complete-dialog.component.html",
	styleUrl: "./task-complete-dialog.component.scss"
})
export class TaskCompleteDialogComponent {
	constructor(
		private dialogRef: MatDialogRef<TaskCompleteDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit() {}

	close(confirm: boolean): void {
		this.dialogRef.close(confirm);
	}
}
